export default __webpack_public_path__ + "static/media/secured.94b7f74b.png";